import React, {
  useState,
  useEffect,
} from 'react';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import XLSX from 'xlsx';

import {
  uiActions,
} from 'web-actions';

import {
  getUiState,
} from 'web-selectors';

import {
  Flex,
} from 'web-styled';

import {
  Tabs,
  Spinner,
} from 'web-components';

import * as S from './styled';

type Props = {
  documentId: number;
  documentUrl: string;
};

const mapState = state => ({
  fileDownload: getUiState('fileDownload')(state),
});

const SpreadsheetPreview = ({
  documentId,
  documentUrl,
}: Props) => {
  const [worksheet, setWorksheet] = useState<string>('');
  const { fileDownload } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  const file = fileDownload[documentId];
  useEffect(() => {
    if (!file) {
      dispatch(
        uiActions.requestDownloadDocument({
          documentId,
          documentUrl,
        }),
      );
    }
  }, [file]);

  if (!file?.success) {
    return (
      <S.Preview>
        <Spinner message="Processing..." />
      </S.Preview>
    );
  }

  const initial = file.workbook.SheetNames[0];
  const ws = file.workbook.Sheets[worksheet || initial];
  const html = {
    __html: XLSX.utils.sheet_to_html(ws),
  };

  return (
    <S.Preview>
      <Tabs
        active={worksheet || initial}
        onRequestChange={setWorksheet}
      >
        {file.workbook.SheetNames.map(name => (
          <Flex
            key={name}
            value={name}
            label={name}
            width="100%"
          >
            <S.TableWrapper dangerouslySetInnerHTML={html} />
          </Flex>
        ))}
      </Tabs>
    </S.Preview>
  );
};

export default SpreadsheetPreview;
